import classNames from 'classnames'
import * as React from 'react'

import {useUserDisplayName} from '../../../../../hooks/useUserDisplayName'
import type {User} from '../../../../../services/rest'
import {noop} from '../../../../../utils/empty'
import commonStyles from '../../../../pages/AgentsPages/components/EnableAgentForm/EnableAgentForm.css'
import EnableComment from '../../../../pages/AgentsPages/components/EnableAgentForm/EnableComment'
import EnableToggle from '../../../../pages/AgentsPages/components/EnableAgentForm/EnableToggle/EnableToggle'

import ownStyles from './AgentToggle.css'

type Props = {
  className?: string
  isToggleable?: boolean
  isCloud?: boolean
  enabled?: boolean
  commentText?: string | null | undefined
  commentTimestamp?: string | null | undefined
  commentUser?: User | undefined
  handleToggleClick?: () => unknown
}

function AgentToggle(props: Props) {
  const {
    className,
    enabled = false,
    isToggleable = false,
    isCloud = false,
    commentText,
    commentUser,
    commentTimestamp,
    handleToggleClick = noop,
  } = props
  const commentUserDisplayName = useUserDisplayName(commentUser)
  const classes = classNames(commonStyles.agentToggle, className)
  const toggle = (
    <EnableToggle
      enabled={enabled}
      isToggleable={isToggleable}
      isCloud={isCloud}
      handleToggleClick={handleToggleClick}
    />
  )
  return (
    <span className={classes}>
      {commentText == null ? (
        toggle
      ) : (
        <EnableComment
          enabled={enabled}
          commentText={commentText}
          commentTimestamp={commentTimestamp}
          commentUser={commentUserDisplayName}
          anchor={toggle}
          iconClassName={ownStyles.commentIcon}
        />
      )}
    </span>
  )
}

export default AgentToggle
